import React from "react";

import "./style.css";

interface Props {
  label: string;
  value: string;
  type: string;
  fs?: string;
  minHeight?: string;
  handleOnChange: any //(event: React.ChangeEvent<HTMLInputElement>) => void;
}

const InputField: React.FC<Props> = ({
  label,
  value,
  minHeight,
  fs="14px",
  type = "text",
  handleOnChange,
}) => (
  <span className={`input-container ${!!value && "input-was-active"}`}>
    <input
      value={value}
      style={{ minHeight,fontSize:fs }}
      type={type}
      id={label}
      onChange={(e)=>handleOnChange(e.target?.value)}
    />
    {label && <label>{label}</label>}
  </span>
);

export default InputField;
